import { z } from "zod";

export const CurrencySchema = z.object({
    value: z.string(), // Kode mata uang
    text: z.string(), // Nama lengkap mata uang
});

export const CurrencyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(CurrencySchema), // Array dari currency objects
});

export type Currency = z.infer<typeof CurrencySchema>;